<template>
  <div>
    <button :title="data_title" class="btnCustom btnCustom-md btnCustom__warning-outline">
      {{ data_name }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'CreateNewButton',
  props: {
    title: {
      type: String,
    },
    name: {
      type: String,
    },
  },
  data: function () {
    return {
      data_title: this.$t('create_new'),
      data_name: this.$t('create_new'),
    };
  },
  mounted: function () {
    this.setData();
  },
  methods: {
    setData: function () {
      if (this.title !== undefined && this.title !== null) this.data_title = this.title;
      if (this.name !== undefined && this.name !== null) this.data_name = this.name;
    },
  },
};
</script>

<style scoped></style>
